var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPendingTickWarning = function SvgPendingTickWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67.415,
    height: 55.302,
    viewBox: "0 0 67.415 55.302",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18855",
    "data-name": "Group 18855",
    transform: "translate(-681.761 -446.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_verified_1983696",
    transform: "translate(1007.729 586.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M60.022,34.4a8.065,8.065,0,0,1,0-6.573l.311-.692c1.991-4.382-.311-9.456-5.041-11.3l-.685-.288a8.805,8.805,0,0,1-5.041-4.671l-.249-.577A9.772,9.772,0,0,0,37.06,5.629l-.622.231a10.193,10.193,0,0,1-7.156,0l-.56-.231a9.671,9.671,0,0,0-12.135,4.728l-.249.461A8.805,8.805,0,0,1,11.3,15.489l-.56.231c-4.667,1.845-6.97,6.919-4.978,11.3l.249.519a8.065,8.065,0,0,1,0,6.573l-.249.634A8.337,8.337,0,0,0,10.8,45.992l.622.231a8.805,8.805,0,0,1,5.041,4.671l.311.634c1.929,4.44,7.405,6.516,12.135,4.728l.685-.288a10.193,10.193,0,0,1,7.156,0l.56.231a9.64,9.64,0,0,0,12.2-4.671l.249-.461A8.805,8.805,0,0,1,54.8,46.4l.5-.173c4.792-1.845,7.032-6.862,5.041-11.3ZM30.4,42.186h0L18.267,32.73,22,28.636l7.716,6.054L43.345,19.7l4.418,3.46L30.4,42.186Z",
    transform: "translate(-331 -142)",
    fill: "#f5722c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17741",
    "data-name": "Group 17741",
    transform: "translate(734.229 446.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M7.479,0A1.124,1.124,0,0,0,6.5.574L.16,11.659a1.161,1.161,0,0,0,0,1.161,1.121,1.121,0,0,0,.981.574H13.818a1.121,1.121,0,0,0,.981-.574,1.175,1.175,0,0,0,0-1.161L8.455.574A1.124,1.124,0,0,0,7.479,0Zm0,.706A.488.488,0,0,1,7.871.93l6.344,11.09a.468.468,0,0,1,0,.437.506.506,0,0,1-.4.231H1.141a.5.5,0,0,1-.4-.231.468.468,0,0,1,0-.437L7.088.93A.488.488,0,0,1,7.479.706Zm0,3a.348.348,0,0,0-.343.35V8.986a.349.349,0,0,0,.343.356.345.345,0,0,0,.337-.356V4.053A.343.343,0,0,0,7.479,3.7Zm0,6.344a.528.528,0,1,0,.506.525A.52.52,0,0,0,7.479,10.047Z",
    transform: "translate(-0.004 0)",
    fill: "#f5722c"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPendingTickWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pendingTickWarning.ebb313f7.svg";
export { ForwardRef as ReactComponent };